import { BACKEND_CONFIG } from '../config/backendConfig';
const BASE_URL = `${BACKEND_CONFIG.baseURL}/camps`;

export interface Camp {
  event_id: string;
  event_name: string;
  start_date: string;
  end_date: string;
  registration_deadline: string | null;
  location_city: string | null;
  location_state: string | null;
  location_zip: string | null;
  event_type: string | null;
  activity_type: string | null;
  price: number | null;
  cost_display: string | null;
  ages: string | null;
  grade_range: string | null;
  gender: string | null;
  is_sold_out: boolean;
  registration_over: boolean;
  registration_ending: boolean;
  wait_list: boolean;
  almost_sold_out: boolean;
  logo_url: string | null;
  registration_url: string | null;
  organizer: string | null;
  date_range: string | null;
  ryzer_verified: boolean;
  distance_miles?: number;
}

export interface CampFilters {
  state?: string;
  activityType?: string;
  eventType?: string;
  gender?: string;
  startDate?: string;
  endDate?: string;
  nearMe?: boolean;
  page?: number;
  limit?: number;
}

export interface CampsResponse {
  camps: Camp[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface CampFilterOptions {
  states: string[];
  activityTypes: string[];
  eventTypes: string[];
  genders: string[];
}

export async function getCamps(token: string, filters: CampFilters = {}): Promise<CampsResponse> {
  const params = new URLSearchParams();

  if (filters.state) params.append('state', filters.state);
  if (filters.activityType) params.append('activityType', filters.activityType);
  if (filters.eventType) params.append('eventType', filters.eventType);
  if (filters.gender) params.append('gender', filters.gender);
  if (filters.startDate) params.append('startDate', filters.startDate);
  if (filters.endDate) params.append('endDate', filters.endDate);
  if (filters.nearMe) params.append('nearMe', 'true');
  if (filters.page) params.append('page', filters.page.toString());
  if (filters.limit) params.append('limit', filters.limit.toString());

  const response = await fetch(`${BASE_URL}?${params.toString()}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });

  if (!response.ok) throw new Error('Failed to fetch camps');
  return response.json();
}

export async function getCampFilters(token: string): Promise<CampFilterOptions> {
  const response = await fetch(`${BASE_URL}/filters`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });

  if (!response.ok) throw new Error('Failed to fetch camp filters');
  return response.json();
}
